import request from './request.js';

/**
 * @param query
 * @returns {Promise<any>}
 */
function sendQuery(query) {
    const encodedQuery = encodeURIComponent(query);

    const options = {
        endpoint: `/coverage/inquiry?inquiry=${ encodedQuery }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    sendQuery
};